<script lang="ts" module>
  import { page } from '$app/stores';
  import { colorVar } from '@yp/web.app/styles.ts';

  type NavLink = {
    section: Section;
    current: boolean;
  };
</script>

<script lang="ts">
  import { userContext } from '#lib/context.svelte.ts';
  import { Icon } from '@yp/web.app/gui/index.ts';
  import { classes, styles } from '@yp/web.app/gui/util.ts';
  import { getSection, type Section } from '@yp/web.app/section.ts';
  import { Sections } from '../sections.ts';

  const uctx = userContext();
  let navLink: NavLink[] = Object.values(Sections).map((section) => ({ section, current: false }));

  function updateCurrent(path: string) {
    const current = getSection(path, Sections);
    navLink.forEach((l) => (l.current = l.section === current));
    navLink = navLink;
  }

  $: updateCurrent($page.url.pathname);

  // $: console.log('bottomNav', $page.url.pathname, ...navLink.map((l) => l.current));
</script>

<nav>
  <div class="nav-bar mx-auto max-w-full h-12 flex justify-between overflow-hidden">
    {#each navLink as link (link.section.label)}
      {@const scheme = link.section.scheme}
      {#if !link.section.hide || uctx.isAtParty}
        <a
          href={link.section.href}
          style={styles(colorVar(scheme, 'bg', '--nl-bg'), colorVar(scheme, 'fg', '--nl-fg'))}
          class={classes(
            'nav-link transition transition-all duration-1000 ease-in-out overflow-hidden',
            'text-sm font-medium font-inter text-black active:brightness-90 border-white border-x-2 border-t-4',
            link.current ? 'current' : 'hover:!brightness-110',
            'py-2 flex items-center',
          )}
          aria-current={link.current ? 'page' : undefined}
          aria-hidden={link.current ? undefined : 'true'}>
          {#if link.section.icon}
            <span class="link-icon transition-all duration-1000 ease-in-out"
              ><Icon icon={link.section.icon} /></span>
          {/if}
          <span class="link-label transition-all duration-1000 ease-in-out"
            >{link.section.label}</span>
        </a>
      {/if}
    {/each}
  </div>
</nav>

<style lang="scss">
  .nav-link {
    text-align: center;
    background-color: var(--nl-bg);

    flex: 1 1 10%;
    justify-content: center;

    &:first-child {
      border-left: 0px;
    }

    &:last-child {
      border-right: 0px;
    }

    .link-icon {
      // flex: 1;
      // flex-shrink: 0;
      // width: 100%;
      width: min-content;
      margin: 0 2px;
      min-width: 100%;
      color: white;
      -webkit-filter: drop-shadow-sm(2px 2px 2px rgba(0, 0, 0, 0.7));
      filter: drop-shadow-sm(2px 2px 2px rgba(0, 0, 0, 0.7));

      & > :global(*) {
        margin: 0 auto;
      }
    }

    .link-label {
      // flex-shrink: 0;
      // width: min-content;
      // width: 0;
      // opacity: 0;
      // display: none;
      width: min-content;
      margin: 0 2px;
      max-width: 0;
    }

    &.current {
      flex-grow: 2.5;
      // justify-content: center;

      .link-icon {
        // margin-left: 0.25em;
        // width: 2.25em;
        min-width: 0;
        // flex: 0;
        color: black;
        -webkit-filter: initial;
        filter: initial;
      }

      .link-label {
        // opacity: 1;
        // display: initial;
        // width: min-content;
        max-width: 20vw;
      }
    }
  }
</style>
